import { Redux } from '../../../@types'

const subState = (state: Redux) => state.playback

export const selectPlaybackData = (fileId: string) => (state: Redux) => subState(state).data[fileId]
